// extracted by mini-css-extract-plugin
export var container = "_hk-0";
export var content = "_hk-3";
export var customerTitle = "_hk-4";
export var empty = "_hk-5";
export var gray = "_hk-6";
export var header = "_hk-7";
export var info = "_hk-8";
export var loading = "_hk-2";
export var loadingCard = "_hk-9";
export var oneLine = "_hk-a";
export var personName = "_hk-e";
export var pillContainer = "_hk-b";
export var selected = "_hk-1";
export var text = "_hk-c";
export var twoLines = "_hk-d";
export var unread = "_hk-f";
export var unreadIndicator = "_hk-g";